var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgExpandIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15.44,
    height: 15.44,
    viewBox: "0 0 15.44 15.44",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_6704",
    "data-name": "Group 6704",
    transform: "translate(-100.28 -696)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6703",
    "data-name": "Group 6703",
    transform: "translate(100.28 696)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3835",
    "data-name": "Path 3835",
    d: "M15.44,0H0V15.44H15.44Z",
    transform: "translate(0)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "arrow-bar-left",
    transform: "translate(2.399 1.815)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4591",
    "data-name": "Path 4591",
    d: "M4.645,10.271a.5.5,0,0,1,.711,0l3.012,3.012a.5.5,0,0,1,0,.711L5.356,17.007a.5.5,0,0,1-.711-.711L7.3,13.639,4.645,10.981a.5.5,0,0,1,0-.711Z",
    transform: "translate(2.53 -7.614)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 0.3,
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4592",
    "data-name": "Path 4592",
    d: "M8.637,10.525a.5.5,0,0,1,.5-.5h6.527a.5.5,0,0,1,0,1H9.14A.5.5,0,0,1,8.637,10.525ZM6.127,16.55a.5.5,0,0,0,.5-.5V5a.5.5,0,1,0-1,0V16.048A.5.5,0,0,0,6.127,16.55Z",
    transform: "translate(-5.625 -4.5)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 0.3,
    fillRule: "evenodd"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgExpandIcon);
export default __webpack_public_path__ + "static/media/expand-icon.ebb0d25d.svg";
export { ForwardRef as ReactComponent };